import { formatReferenceCopy } from 'utils/typography'
import './manager-proposal-dialogs.scss'

import {
  useTranslation,
} from 'react-i18next'
import {
  Button,
  Typography,
} from '@mui/material'

import ModalBig from '../../../../common/modalBig'


const ManagerProposalDialogs = ({ publishProposalConfirmOpen, publishProposalBlockedOpen, setPublishProposalConfirmOpen, setPublishProposalBlockedOpen, handleConfirmPublishProposal }: ApplicationManagerProposalDialogsProps) => {
  const { t } = useTranslation()
  return (<div className='application-manager-proposal-dialogs'>
    <ModalBig
      isOpen={publishProposalConfirmOpen}
      onClose={() => setPublishProposalConfirmOpen(false)}
      title={formatReferenceCopy(t('applications__text__publishProposalConfirmTitle'))}
      width={736}
      buttons={(
        <div className='application-manager-proposal-dialogs__modal-actions'>
          <Button
            variant='outlined'
            sx={{ minWidth: '238px', marginRight: 3 }}
            onClick={() => setPublishProposalConfirmOpen(false)}
          ><Typography component='span' variant='inherit'>
              {formatReferenceCopy(t('actions__text__cancel'))}
            </Typography></Button>
          <Button
            variant='contained'
            fullWidth
            onClick={handleConfirmPublishProposal}
          ><Typography component='span' variant='inherit'>
              {formatReferenceCopy(t('applications__text__publishProposalConfirmAction'))}
            </Typography></Button>
        </div>
      )}
    >
      <Typography variant='body1' className='application-manager-proposal-dialogs__modal-description'>
        {formatReferenceCopy(t('applications__text__publishProposalConfirmBody'))}
      </Typography>
    </ModalBig>

    <ModalBig
      isOpen={publishProposalBlockedOpen}
      onClose={() => setPublishProposalBlockedOpen(false)}
      title={formatReferenceCopy(t('applications__text__publishProposalBlockedTitle'))}
      width={736}
      buttons={(
        <div className='application-manager-proposal-dialogs__modal-actions'>
          <Button
            variant='contained'
            fullWidth
            onClick={() => setPublishProposalBlockedOpen(false)}
          ><Typography component='span' variant='inherit'>
              {formatReferenceCopy(t('actions__text__iUnderstand'))}
            </Typography></Button>
        </div>
      )}
    >
      <Typography variant='body1' className='application-manager-proposal-dialogs__modal-description'>
        {formatReferenceCopy(t('applications__text__publishProposalBlockedBody'))}
      </Typography>
    </ModalBig>
  </div>)
}
export default ManagerProposalDialogs
